import { render, staticRenderFns } from "./RelatorioComercialJobView.vue?vue&type=template&id=f106e31c&scoped=true"
import script from "./RelatorioComercialJobView.vue?vue&type=script&lang=js"
export * from "./RelatorioComercialJobView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioComercialJobView.vue?vue&type=style&index=0&id=f106e31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f106e31c",
  null
  
)

export default component.exports